import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_ADDRESSESS_ENDPOINT } from '@/app/_libs/utils/constants/endpoints';

//get user addresses ********************
async function getUserAddresses(token) {
  const resAddress = await fetch(`${GET_ADDRESSESS_ENDPOINT}`, {
    method: 'get',
    headers: new Headers({
      Authorization: 'Bearer ' + token,
      Accept: 'application/json',
    }),
  });
  return await resAddress.json();
}
//  update user main address*******************************
async function updateUserMainAddress({ userToken, id }) {
  const res = await fetch(`${GET_ADDRESSESS_ENDPOINT}/${id}/default`, {
    method: 'POST',
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  });
  return await res.json();
}
// add new user address *************************************
async function addUserAddress({ userToken, ...values }) {
  const res = await fetch(`${GET_ADDRESSESS_ENDPOINT}`, {
    method: 'POST',
    body: JSON.stringify({
      company: values.company ?? '',
      name: values.name ?? '',
      mobile: values.mobile ?? '',
      surname: values.family ?? '',
      province: values.province,
      city: values.city,
      address: values.postalAddress,
      postal_code: values.postalCode,
      number: values.number,
      unit: values.unit,
      is_self: values.isSelf,
    }),
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  });
  return await res.json();
}
// update user address **********************
async function updateUserAddress({ userToken, ...values }) {
  const url = `${GET_ADDRESSESS_ENDPOINT}/${values.id}/edit`;
  const res = await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      company: values.comapny ?? '',
      name: values.name ?? '',
      mobile: values.mobile ?? '',
      surname: values.family ?? '',
      province: values.province,
      city: values.city,
      address: values.postalAddress,
      postal_code: values.postalCode,
      number: values.number,
      unit: values.unit,
      is_self: values.isSelf,
    }),
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      'Content-Type': 'application/json',
      Accept: 'application/json',
    }),
  });

  return await res.json();
}
// delete user addresses*****************************
async function deletUserAddress({ userToken, id }) {
  const res = await fetch(`${GET_ADDRESSESS_ENDPOINT}/${id}/delete`, {
    method: 'POST',
    headers: new Headers({
      Authorization: 'Bearer ' + userToken,
      Accept: 'application/json',
    }),
  });
  return await res.json();
}

//  hooks ******************************************
const useUserAddresses = (token, initiaData) => {
  const fallback = [];
  const { data: addresses = fallback } = useQuery({
    queryKey: ['addresses', token],
    queryFn: () => getUserAddresses(token),
    initialData: initiaData,
  });
  return { addresses };
};

const useUpdateAddress = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, ...values }) =>
      updateUserAddress({ userToken, ...values }),
    onSuccess: () => {
      queryClient.invalidateQueries(['addresses', token]);
    },
  });
};
const useUpdateMainAddress = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, id }) => updateUserMainAddress({ userToken, id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['addresses', token]);
    },
  });
};
const useDeleteAddress = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, id }) => deletUserAddress({ userToken, id }),
    onSuccess: () => {
      queryClient.invalidateQueries(['addresses', token]);
    },
  });
};
const useAddAddress = (token) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userToken, ...values }) =>
      addUserAddress({ userToken, ...values }),
    onSuccess: () => {
      queryClient.invalidateQueries(['addresses', token]);
    },
  });
};
export {
  useUserAddresses,
  useUpdateAddress,
  useAddAddress,
  useUpdateMainAddress,
  useDeleteAddress,
};
